const Youtube = {
  init: function () {
    if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.onYouTubeIframeAPIReady = this.renderAll;
    } else {
      this.renderAll();
    }
  },

  renderAll: function () {
    const videoBlocks = document.querySelectorAll(".video-block");

    videoBlocks.forEach((videoBlock) => {
      const ytVideoContainer = videoBlock.querySelector(".yt-video");
      const playButton = videoBlock.querySelector(".video-block__play-btn");
      const ytVideoId = ytVideoContainer.getAttribute("id");
      let player;

      function createYouTubePlayer() {
        player = new YT.Player(ytVideoContainer, {
          height: "700",
          width: "1400",
          videoId: ytVideoId,
          playerVars: {
            controls: 1,
            modestbranding: 1,
            rel: 0,
          },
          events: {
            onReady: function (event) {
              playButton.addEventListener("click", function () {
                playButton.parentNode.classList.toggle("loaded");
                event.target.playVideo();
              });
            },
          },
        });
      }

      if (typeof YT !== "undefined" && typeof YT.Player !== "undefined") {
        createYouTubePlayer();
      }
    })
  },
};

export default Youtube;
